import React from 'react';
import { Header, Card, Grid, Icon } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../footer';
import { isICCSupport, canEditAll, isReadOnly } from '../auth';
import '../../css/common.css';

const SupportCard = ({ header, icon, description, href }) => {
    const navigate = useNavigate();
    return (
        <Card
            style={{ minHeight: '8rem', margin: '1rem' }}
            fluid
            header={
                <div
                    style={{
                        fontSize: '1.3rem',
                        fontWeight: 'bold',
                        color: 'black',
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <div>{header}</div>
                    <Icon color="grey" className={icon} />
                </div>
            }
            description={description}
            onClick={() => navigate(href)}
        />
    );
};

export const SupportPage = () => {
    const canManageTypes = !isReadOnly() && (isICCSupport() || canEditAll());
    return (
        <div className="homepage">
            <Header as="h2">Support</Header>
            <Grid style={{ width: '70%' }} stackable>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <SupportCard
                            header="Asset Subtypes"
                            icon="tags"
                            href="/devicesubtypes"
                            description="View, edit and delete asset subtypes. Each subtype has specific information associated with it, such as the fields required."
                        />
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <SupportCard
                            header="DFN"
                            icon="sitemap"
                            href="/support/dfn"
                            description="View, create, edit and delete Distributed Fiber Network Nodes."
                        />
                    </Grid.Column>
                    {canManageTypes && (
                        <Grid.Column width={8}>
                            <SupportCard
                                header="Roadblock Types"
                                icon="list ul"
                                href="/support/roadblock-types"
                                description="Add, edit, and deactivate roadblock types without a code deployment."
                            />
                        </Grid.Column>
                    )}
                </Grid.Row>
            </Grid>
            <Footer />
        </div>
    );
};
